var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-building 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.61629 0C3.35126 0 2.30859 1.04267 2.30859 2.30769V20H17.6932V2.30769C17.6932 1.04267 16.6505 0 15.3855 0H4.61629ZM4.61629 1.53846H15.3855C15.8122 1.53846 16.1547 1.88101 16.1547 2.30769V18.4615H14.6163V14.6154H10.7701V18.4615H3.84706V2.30769C3.84706 1.88101 4.1896 1.53846 4.61629 1.53846ZM5.38552 3.07692V5.38462H9.23167V3.07692H5.38552ZM10.7701 3.07692V5.38462H14.6163V3.07692H10.7701ZM5.38552 6.92308V9.23077H9.23167V6.92308H5.38552ZM10.7701 6.92308V9.23077H14.6163V6.92308H10.7701ZM5.38552 10.7692V13.0769H9.23167V10.7692H5.38552ZM10.7701 10.7692V13.0769H14.6163V10.7692H10.7701ZM5.38552 14.6154V16.9231H9.23167V14.6154H5.38552Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/iconBuilding.e0550b271d88cb9358c358ed7e267a2b.svg";
export { ForwardRef as ReactComponent };